var map = {
	"./404.svg": "a14a",
	"./API.svg": "7e34",
	"./API_LIST.svg": "6cfd",
	"./api_order.svg": "7eaf",
	"./authorization-list.svg": "77b4",
	"./base-info.svg": "0814",
	"./book.svg": "6ac0",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./client-list.svg": "87a7",
	"./client.svg": "037c",
	"./clipboard.svg": "bc35",
	"./company.svg": "9ef7",
	"./companyAnalysis.svg": "261d",
	"./component.svg": "56d6",
	"./constitution.svg": "3932",
	"./customer-service.svg": "853d",
	"./dashboard.svg": "f782",
	"./data-center.svg": "a3a9",
	"./data.svg": "5a0a",
	"./device.svg": "2c87",
	"./dictionary.svg": "30a7",
	"./disease-location.svg": "dc26",
	"./disease-nature.svg": "c2ef",
	"./disease.svg": "6eb1",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./education.svg": "ad1c",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./face-set.svg": "1a85",
	"./faceset.svg": "3042",
	"./file.svg": "b8b2",
	"./finance.svg": "b599",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide.svg": "6683",
	"./hardware.svg": "1e89",
	"./home.svg": "6bbe",
	"./icon.svg": "9d91",
	"./info.svg": "4be3",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./layout.svg": "ebfe",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./log.svg": "fea0",
	"./login-mall.svg": "0de5",
	"./login-shop.svg": "46a3",
	"./marker.svg": "edcd",
	"./menu.svg": "bd3d",
	"./message.svg": "47ff",
	"./module.svg": "7e42",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./order-return-reason.svg": "7355",
	"./order-return.svg": "480b",
	"./order-setting.svg": "e4b6",
	"./order.svg": "11ff",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./permission.svg": "3979",
	"./picture.svg": "b6c6",
	"./prescription.svg": "c886",
	"./product-add.svg": "cbc9",
	"./product-attr.svg": "9741",
	"./product-brand.svg": "60fc",
	"./product-cate.svg": "57a7",
	"./product-comment.svg": "60f4",
	"./product-list.svg": "e2f5",
	"./product-recycle.svg": "5be0",
	"./product.svg": "8d30",
	"./qq.svg": "1430",
	"./role.svg": "520c",
	"./search.svg": "8e8d",
	"./setting.svg": "05ff",
	"./shop.svg": "5def",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./skill.svg": "096e",
	"./software-list.svg": "310c",
	"./software.svg": "16e9",
	"./star.svg": "708a",
	"./statistic.svg": "e33d",
	"./statistics.svg": "a1cf",
	"./store-apply.svg": "be0c",
	"./store-list.svg": "4aa4",
	"./store.svg": "443b",
	"./supplier.svg": "5a3e",
	"./symptom.svg": "ddf4",
	"./syndrome.svg": "5df7",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./therapy.svg": "2356",
	"./total-today.svg": "fda3",
	"./total-week.svg": "aff9",
	"./total-yesterday.svg": "8f00",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./ums-admin.svg": "a945",
	"./ums-menu.svg": "011e",
	"./ums-resource.svg": "a0c7",
	"./ums-role.svg": "32c2",
	"./ums.svg": "e418",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./word.svg": "bcb8",
	"./yaocai-manage.svg": "a503",
	"./yaocai.svg": "7e52",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";